import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex px-4" }
const _hoisted_2 = { class: "w-25 p-1" }
const _hoisted_3 = { class: "w-25 p-1" }
const _hoisted_4 = {
  class: "w-25 p-1",
  style: { minWidth: '100px' }
}
const _hoisted_5 = { class: "w-25 p-1" }

import { computed } from 'vue'
import { SubscriptionInvoice } from '../../../api/v2/models/subscription'
import { format } from 'date-fns'


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionInvoice',
  props: {
    subscriptionInvoice: {},
    downloadingReceiptId: {}
  },
  emits: ["download-receipt"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const date = computed(() => {
  return format(props.subscriptionInvoice.paiedAt, 'YYYY/MM/DD')
})

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(date.value), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.subscriptionInvoice.amountPaid.toLocaleString()) + "円", 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_chip, {
        class: "me-2 text-white",
        color: "blue",
        small: "",
        label: ""
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" 支払い済み ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_btn, {
        color: "primary",
        outlined: "",
        small: "",
        loading: __props.downloadingReceiptId === __props.subscriptionInvoice.id,
        disabled: __props.downloadingReceiptId === __props.subscriptionInvoice.id,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('download-receipt', __props.subscriptionInvoice.id)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            small: "",
            class: "mr-1"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-file-pdf-box", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" 領収書 ", -1 /* CACHED */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["loading", "disabled"])
    ])
  ]))
}
}

})